<template>
	<div class="contact_us">
		<b-spinner variant="success"
		    class="spinStyle"
		    v-show="showSpin"
		    label="Text Centered"></b-spinner>
		<b-table id="refund-table"
		    :fields="refundtableTab.refundFields"
		    :items="refundtableTab.refundList"
		    small
		    bordered
		    hover
		    show-empty
		    empty-text="没有找到匹配的记录"
		    caption-top
		    :busy="refundtableTab.isTableBusy">
		    <template slot="table-caption">
		        <b-button style="float:right;"
		            size="sm"
					variant="success"
		            v-on:click="onAddRefund()">
		            申请余额提现
		        </b-button>
		    </template>
		    <div slot="table-busy"
		        class="text-center text-info my-2">
		        <b-spinner class="align-middle" variant="success"></b-spinner>
		        <strong>加载中...</strong>
		    </div>
		    <template v-slot:cell(refundCreatedAt)="row">
		        <span>{{formatDateTimeString(row.item.refundCreatedAt)}}</span>
		    </template>
		    <template v-slot:cell(refundRepliedAt)="row">
		        <span>{{formatDateTimeString(row.item.refundRepliedAt)}}</span>
		    </template>
		    <template v-slot:cell(refundStatus)="row">
		        <span v-if="row.item.refundStatus === 0" style="color: seagreen;">审核中</span>
		        <span v-else-if="row.item.refundStatus === 1" style="color: royalblue;">已提现</span>
		        <span v-else-if="row.item.refundStatus === 2" style="color: red;">提现失败</span>
		        <span v-else style="color: black;">撤销提现</span>
		    </template>
		    <template v-slot:cell(actionButton)="row">
		        <a href="#"
		            v-on:click="onWithDrewRefund(row)" v-show="row.item.refundStatus === 0" >撤回申请</a>
		    </template>
		</b-table>
		
		<!-- 分页 -->
		<div class="pageControl">
		    <b-pagination v-model="refundtableTab.refundSearch.limit.conditions.pageStart"
		        style="margin-top:20px;"
				:total-rows="refundtableTab.refundSearch.limit.conditions.total"
		        :per-page="refundtableTab.refundSearch.limit.conditions.pageLength"
		        align="center"
		        size="sm"
		        ellipsis-text="..."
		        first-text="首页"
		        prev-text="上一页"
		        next-text="下一页"
		        last-text="尾页"
		        limit="10"
		        @change="onRefundPageChange"></b-pagination>
		</div>		
	<!-- 申请余额提现 -->
	<b-modal id="refundtableTab.refundModel"
		v-model="refundtableTab.refundModel.show"
		:title="refundtableTab.refundModel.title"
		no-close-on-backdrop>
		<b-row align-v="center">
		    <b-col lg="12">
		        <b-form>
					<span class="title">申请余额提现</span>
					<b-form-group label="提现金额:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm">
					    <b-form-input v-model="refundtableTab.refundModel.refundAmount"
					        size="sm"
					        required autocomplete="off" 
					        placeholder="请输入提现金额"></b-form-input>
					</b-form-group>
					<b-form-group label="备注:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm">
					    <b-form-input v-model="refundtableTab.refundModel.remark"
					        size="sm" autocomplete="off" ></b-form-input>
					</b-form-group>
					<hr>
					<span class="title">收款方式</span>
					<b-form-group label="收款类型:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm">
					    <b-form-radio-group 
					    size="sm" v-model="refundtableTab.refundModel.refundWay" >
					        <b-form-radio value="1" name="银行卡" >银行卡</b-form-radio>
					        <b-form-radio value="2" name="转入其他会员号" >转入其他会员号</b-form-radio>
					    </b-form-radio-group>
					</b-form-group>
					<b-form-group label="银行名称:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm" v-if="refundtableTab.refundModel.refundWay == 1">
					    <b-form-input v-model="refundtableTab.refundModel.bankName" 
					        size="sm" autocomplete="off" 
					        placeholder="必填"></b-form-input>
					</b-form-group>
					<b-form-group label="银行卡号:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm" v-if="refundtableTab.refundModel.refundWay == 1">
					    <b-form-input v-model="refundtableTab.refundModel.bankAccount" 
					        size="sm" autocomplete="off" 
					        placeholder="必填"></b-form-input>
					</b-form-group>
					<b-form-group label="银行分行:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm" v-if="refundtableTab.refundModel.refundWay == 1">
					    <b-form-input v-model="refundtableTab.refundModel.bankBranchName" 
					        size="sm" autocomplete="off" 
					        placeholder="必填"></b-form-input>
					</b-form-group>
					
					<b-form-group label="会员号:"
					    label-cols-lg="3"
					    label-align-lg="right"
					    label-size="sm" v-if="refundtableTab.refundModel.refundWay == 2">
					    <b-form-input v-model="refundtableTab.refundModel.receiveUserName" 
					        size="sm" autocomplete="off" 
					        placeholder="必填"></b-form-input>
					</b-form-group>
				</b-form>
		    </b-col>
		</b-row>	
				
		<template slot="modal-footer">
			<b-button size="sm"
				variant="success"
				@click="refundtionInfo()">
				<b-spinner small
					v-if="refundtableTab.modifyrefundBusySpin"></b-spinner>
				提交申请
			</b-button>
			<b-button size="sm"
				variant="danger"
				@click="refundtableTab.refundModel.show = false">
				取消
			</b-button>
		</template>
	</b-modal>
	</div>	
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import HttpRequest from '@/libs/axios';
import { formatDateTimeString, numberToFixed } from "@/libs/utils";
export default {
    name:"RefundList",
    data() {
        return {
			showSpin: false,
            refundtableTab: {
			    refundFields: [
                    { key: 'refundNo', label: '余额提现单号' },
			        { key: 'refundAmount', label: '提现金额' },
			        { key: 'remark', label: '备注' },
			        { key: 'refundStatus', label: '状态' },
			        { key: 'actionButton', label: '操作' }
			    ],
			    refundList: [],
			    isTableBusy: false,
			    refundSearch: search.getSearchParams(),
			    refundModel: {
			    	show: false,
			    	title: '',
			    	refundAmount: 0,
			    	userName: '',
			    	userPersonName: '',
			    	remark: '',
			    	refundWay: 1,
			    	bankName: '',
			    	bankAccount: '',
			    	bankBranchName: '',
			    	receiveUserName: ''
			    },
                modifyrefundBusySpin: false
            }
        };
    },
    mounted() {
        this.getRefundList();
    },
    methods: {
		// 获取余额提现单列表
    	getRefundList() {
			if (this.checkMemberLogin()) {
				this.showSpin = true;
			    api.webGetRefundList(this.refundtableTab.refundSearch).then(res => {
				 this.showSpin = false;
			        if (res.code === 0) {
			            this.refundtableTab.refundList = res.data.records;
			            search.globalSetFilterRecordCount(this.refundtableTab.refundSearch, res.data.filterRecordCount);
			        }
			    });
			}
    	},
		// 撤回申请
		onWithDrewRefund(row){
			this.$bvModal.msgBoxConfirm('是否确认撤回该申请？', {
			    size: 'sm',
			    buttonSize: 'sm',
			    okVariant: 'danger',
			    okTitle: '是',
			    cancelTitle: '否'
			}).then(value => {
			    if (value) {
			        api.getCancelRefund({
			            id: row.item.id
			        }).then(res => {
			            if (res.code === 0) {
			                this.getRefundList();
			            }
			        });
			    }
			});
		},
		// 申请余额提现弹框
		onAddRefund(){
			this.refundtableTab.refundModel.title = '申请余额提现';
			this.refundtableTab.refundModel.refundUuid = '';
			this.refundtableTab.refundModel.refundAmount = 0;
			this.refundtableTab.refundModel.remark = '';
			this.refundtableTab.refundModel.refundWay = 1;
			this.refundtableTab.refundModel.userName = '';
			this.refundtableTab.refundModel.userPersonName = '';
			this.refundtableTab.refundModel.bankName = '';
			this.refundtableTab.refundModel.bankAccount = '';
			this.refundtableTab.refundModel.bankBranchName = '';
			this.refundtableTab.refundModel.receiveUserName = '';
			this.refundtableTab.refundModel.show = true
		},
		// 添加申请余额提现
		refundtionInfo(){
			if(this.refundtableTab.refundModel.refundAmount == null || this.refundtableTab.refundModel.refundAmount == '') 
			return this.$bvModal.msgBoxOk("请输入提现金额", {
			            title: '提示',
			            buttonSize: 'sm'
			        });
			this.refundtableTab.modifyrefundBusySpin = true;
			this.showSpin = true;
			api.getSaveRefund(this.refundtableTab.refundModel).then(res => {
				 this.showSpin = false;
			    this.refundtableTab.modifyrefundBusySpin = false;
			    if (res.code === 0) {
			        this.$bvModal.msgBoxOk("申请已提交", {
			            title: '提示',
			            buttonSize: 'sm'
			        });
			        this.refundtableTab.refundModel.show = false;
			        this.getRefundList();
			    }
			});
		},
		// 分页
		onRefundPageChange(pageNum){
			search.globalPageOnChange(this.refundtableTab.refundSearch, pageNum);
			this.getRefundList();
		},
    }
};
</script>

<style scope>
.dataTable th{
	background-color: #fff;
	white-space: nowrap;
	line-height:40px;
	text-align: center;
	}
.table td a{color: #00b151;}
/* 页码样式 */
.page-link{color:#757575 !important;}
 .page-link:hover{color: #00b151 !important;}
 .page-item.active .page-link{color:#fff !important;background-color: #28a745 !important;border-color: #28a745 !important;}
 .pagination-sm .page-link{
 	padding: 5px 12px !important;
 	margin-top: 40px;
 	}	
.page-link:focus{box-shadow: none !important;}	
.title {
	font-size: 24px;
	font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/view/refund/refund-list.vue